








































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import Loading from '@/app/components/Common/Loading.vue'
import PageTitle from '@/app/components/Common/PageTitle.vue'
import ProfitHeader from '@/app/components/Profit/ProfitHeader.vue'
import ProfitForcast from '@/app/components/Profit/ProfitForcast.vue'
import ProfitResults from '@/app/components/Profit/ProfitResults.vue'
import ProfitForcastGraphApi from '@/app/model/api/profitForcastGraphApi'
import ProfitForcastListApi from '@/app/model/api/profitForcastListApi'
import ProfitResultGraphApi from '@/app/model/api/profitResultGraphApi'
import ProfitResultListApi from '@/app/model/api/profitResultListApi'
/* module */
import CommonClass from '@/app/module/common'
import { plantingSeason, routerPath, errorFlag } from '@/app/model/store/domain/const'

@Component({
  components: {
    CommonHeader,
    PageTitle,
    Loading,
    ProfitHeader,
    ProfitForcast,
    ProfitResults
  }
})
export default class Profit extends Vue {
  private selectedYear: string = ''
  private selectedSeason: string = ''
  private selectedDisplayType: string = 'forcast'
  private selectedListType: string= 'loss'
  private graphData: any = {}
  private listData: any = {}
  private riskListData: any = {}
  private errorMessage: string = ''
  /* 表示非表示 */
  private renderForocast: boolean = false
  private renderResults: boolean = false
  private showLoading: boolean = true

  private get changeSeason (): number {
    return this.$store.state.profitState.selectedSeason
  }
  private get changeYear (): number {
    return this.$store.state.profitState.selectedYear
  }
  @Watch('changeSeason')
  onSeasonChange (newValue: string) {
    this.selectedSeason = newValue
    this.selectedListType = 'loss'
    this.changeDisplay()
  }
  @Watch('changeYear')
  onYearChange (newValue: string) {
    this.selectedYear = newValue
    this.selectedListType = 'loss'
    this.changeDisplay()
  }

  destroyed () {
    this.$store.commit('profitState/setSelectedSeason', '')
    this.$store.commit('profitState/setSelectedYear', '')
  }

  created () {
    // 現在の年とシーズンを取得
    this.selectedYear = String(new Date().getFullYear())
    this.selectedSeason = String(plantingSeason.MAIN)

    // 初期表示は予測のデータを取得
    this.getForecastgraphData()
  }

  /* 年度・シーズン変更 */
  private changeDisplay () {
    if (this.selectedDisplayType === 'forcast') {
      this.renderForocast = false
      this.getForecastgraphData()
    } else if (this.selectedDisplayType === 'results') {
      this.renderResults = false
      this.getResultsGraphData()
    }
  }

  /* 予測グラフ */
  private getForecastgraphData () {
    (async () => {
      this.showLoading = true
      const result = await ProfitForcastGraphApi.getForcastGraph(this.selectedYear, this.selectedSeason)

      if (result.isOk()) {
        // データ取得
        this.graphData = result.getPayload()
        // リストも取得
        this.getForcastListData()
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }

  /* 予測一覧 */
  private getForcastListData () {
    (async () => {
      // 初期のtype=loss(欠損)
      const result = await ProfitForcastListApi.getForcastList(this.selectedYear, this.selectedSeason, this.selectedListType)

      if (result.isOk()) {
        // データ取得
        if (this.selectedListType === 'loss') {
          this.listData = result.getPayload().loss_factor_list
          this.riskListData = result.getPayload().loss_factor_risk_list
        } else {
          this.listData = result.getPayload()
        }

        // 予測リストのタブ切り替えデータ
        let forcast: any = this.$refs.forcast
        if (forcast !== undefined) {
          forcast.changeList(this.listData)
        }

        // prop可能
        this.renderForocast = true
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }

  /* 実績グラフ */
  private getResultsGraphData () {
    (async () => {
      this.showLoading = true
      const result = await ProfitResultGraphApi.getResultGraph(this.selectedYear, this.selectedSeason)
      if (result.isOk()) {
        // データ取得
        this.graphData = result.getPayload()
        // リストも取得
        this.getResultsListData()
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }

  /* 実測一覧 */
  private getResultsListData () {
    (async () => {
      const result = await ProfitResultListApi.getResultList(this.selectedYear, this.selectedSeason)
      if (result.isOk()) {
        // データ取得
        this.listData = result.getPayload()

        // prop可能
        this.renderResults = true
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }

  /* リスト絞り込み */
  public changeList (val: string) {

  }

  /* タブ変更検知 */
  public changeTab (val: string) {
    this.renderForocast = false
    this.renderResults = false

    // 1=予測 2=実績
    if (val === '1') {
      // 画面切り替えた場合は初期値に戻す
      this.selectedListType = 'loss'
      this.selectedDisplayType = 'forcast'
      this.getForecastgraphData()
    } else if (val === '2') {
      this.selectedDisplayType = 'results'
      this.getResultsGraphData()
    }
  }

  /* リストの収穫・欠損のタブ切り替え */
  public changeListType (val: string) {
    const TAB_HARVEST = '1'
    const TAB_LOSS = '2'

    if (val === TAB_HARVEST) {
      this.selectedListType = 'harvest'
    } else {
      this.selectedListType = 'loss'
    }

    this.getForcastListData()
  }
}
